import { Exclude, Expose } from 'class-transformer';
import { BaseModel } from './base.model';

export type DataSetupSelectOption = {
  key: string;
  value: any;
};

export type DataSetupSelectConstrainKey = 'min' | 'max' | 'unique' | 'single' | 'readonly';

export type DataSetupSelectOptionConstrain = DataSetupSelectOption & {
  constrain: Record<DataSetupSelectConstrainKey, boolean | number>[];
};

@Exclude()
export class DataSetupModel extends BaseModel {
  @Expose()
  boardResolutionModes!: DataSetupSelectOption[] | null;

  @Expose()
  businessActivities!: DataSetupSelectOption[] | null;

  @Expose()
  businessConstitution!: DataSetupSelectOption[] | null;

  @Expose()
  businessOwnership!: DataSetupSelectOption[] | null;

  @Expose()
  crsTypeOfFinancial!: DataSetupSelectOption[] | null;

  @Expose()
  collateralPropertyCompletionStatus!: DataSetupSelectOption[] | null;

  @Expose()
  collateralPropertyTypes!: DataSetupSelectOption[] | null;

  @Expose()
  collateralPropertyLandTitles!: DataSetupSelectOption[] | null;

  @Expose()
  collateralPropertyTenures!: DataSetupSelectOption[] | null;

  @Expose()
  collateralPropertyPurposes!: DataSetupSelectOption[] | null;

  @Expose()
  genders!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelAppointments!: DataSetupSelectOptionConstrain[] | null;

  @Expose()
  keyPersonnelMaritalStatus!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelResidency!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelRaces!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelPassTypes!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelPassStatuses!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelHdbTypes!: DataSetupSelectOption[] | null;

  @Expose()
  keyPersonnelHousingTypes!: DataSetupSelectOption[] | null;

  @Expose()
  minimumAmountReceiveNotifications!: DataSetupSelectOption[] | null;
}
